export const captureActiveProduct = () => {
  const pathname = window.location.pathname;
  if (pathname.includes('/door-insights')) {
    window.localStorage.setItem('activeProduct', 'DoorInsights');
  }
  if (pathname.includes('/occupancy-insights')) {
    window.localStorage.setItem('activeProduct', 'OccupancyInsights');
  }
};
